import React from 'react';
import { TextArea } from '@pwc/pwc-deals-ui';
import { useAutoResize } from '../../features/analyses/structured-analysis/common/hooks/useAutoResize';

const SourceInput = (props) => {
  const {
    field,
    showEditIcon,
    labelIcon,
    includeSeparator,
    placeholder = 'Start typing here to give your analysis a source',
  } = props;
  useAutoResize(field.value, 'source');
  return (
    <>
      <div data-testid="source-input-container">
        <TextArea
          name="source"
          field={field}
          label="Source"
          placeholder={placeholder}
          helperText="Include a description referencing the original data source."
          helperIcon="information"
          helperIconColor="yellow"
          maxLength={100}
          basic
          showEditIcon={showEditIcon}
          labelIcon={labelIcon}
          includeSeparator={includeSeparator}
        />
      </div>
    </>
  );
};

export default SourceInput;
